import client from '../client';

const PATH = '/tagged-features'

/**
 * Create a tagged feature for the given product item's feature.
 * @param {Object} params
 * @param {Number} params.dataId the id of the data of the product where the tag exists
 * @param {Number} params.featureId the id of the feature
 * @param {Number} params.offset the index of the first character of the tagged feature
 *  where the value starts
 * @param {String} params.value the raw string tagged
 */
function create({ dataId, featureId, offset, value }) {
  return client.post(PATH, { dataId, featureId, offset, value }).then(({ data }) => data)
}

/**
 * Remove a tagged feature from the database by its id
 *
 * @param {Number} id
 */
function remove(id) {
  return client.delete(`${PATH}/${id}`)
}

export default {
  create,
  remove
}